import { render, staticRenderFns } from "./ProductDiscountList.vue?vue&type=template&id=186898e4&scoped=true&"
import script from "./ProductDiscountList.vue?vue&type=script&lang=js&"
export * from "./ProductDiscountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186898e4",
  null
  
)

export default component.exports